import '@react-awesome-query-builder/ui';
import { toOption as toOption$1 } from '@grafana/data';
import 'lodash';
import 'react/jsx-runtime';
import '@grafana/ui';
import 'react';
import '../SQLEditor/standardSql/language.js';
import 'uuid';
import '@grafana/runtime';
import '../SQLEditor/utils/debugger.js';
import '../SQLEditor/standardSql/macros.js';

var _a;
var QueryFormat = /* @__PURE__ */ ((QueryFormat2) => {
  QueryFormat2[QueryFormat2["Timeseries"] = 0] = "Timeseries";
  QueryFormat2[QueryFormat2["Table"] = 1] = "Table";
  QueryFormat2[QueryFormat2["Logs"] = 2] = "Logs";
  QueryFormat2[QueryFormat2["Trace"] = 3] = "Trace";
  QueryFormat2[QueryFormat2["OptionMulti"] = 4] = "OptionMulti";
  return QueryFormat2;
})(QueryFormat || {});
var EditorMode = /* @__PURE__ */ ((EditorMode2) => {
  EditorMode2["Builder"] = "builder";
  EditorMode2["Code"] = "code";
  return EditorMode2;
})(EditorMode || {});
const QUERY_FORMAT_OPTIONS = [
  { label: "Time series", value: 0 /* Timeseries */ },
  { label: "Table", value: 1 /* Table */ }
];
const backWardToOption = (value) => ({ label: value, value });
const toOption = (_a = toOption$1) != null ? _a : backWardToOption;

export { EditorMode, QUERY_FORMAT_OPTIONS, QueryFormat, toOption };
//# sourceMappingURL=types.js.map
